import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";

export const Wrapper = withViewportStyle("div")`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(24)};

  .button-primitive {
    ${baseButtonStyle}
    margin: ${rem(40)} auto 0;
  }

  .z-index-lowest {
    z-index: var(--z-index-lowest);
  }

  .background-squiggle {
    position: absolute;
    top: 150px;
    left: -24px;
    transform: rotate(-35deg);
  }

  ${(props) =>
    props.$viewport.mobile`
      grid-template-columns: 1fr;
      grid-gap: ${rem(8)};

      .button-primitive {
        width: 100%;
        margin-top: ${rem(24)};
      }
  `}
`;
